import React from 'react';
import { Steps, ConfigProvider } from 'antd';
import useDefaultTrebbleAntDTokenConfig from '../helper/useDefaultTrebbleAntDTokenConfig';

interface StepItem {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  status?: 'wait' | 'process' | 'finish' | 'error';
  disabled?: boolean;
}

interface TrebbleStepsProps {
  current?: number;
  direction?: 'horizontal' | 'vertical';
  size?: 'default' | 'small';
  status?: 'wait' | 'process' | 'finish' | 'error';
  items?: StepItem[];
  className?: string;
  style?: React.CSSProperties;
  onChange?: (current: number) => void;
  children?: React.ReactNode;
}

const TrebbleSteps: React.FC<TrebbleStepsProps> = ({
  current = 0,
  direction = 'horizontal',
  size = 'default',
  status,
  items,
  className = '',
  style,
  onChange,
  children,
  ...props
}) => {
  const tokenConfig = useDefaultTrebbleAntDTokenConfig();
  
  const combinedClassName = `trebble-steps font-bold ${className}`;
  
  return (
    <ConfigProvider theme={tokenConfig}>
      <Steps
        current={current}
        direction={direction}
        size={size}
        status={status}
        items={items}
        className={combinedClassName}
        style={style}
        onChange={onChange}
        {...props}
      >
        {children}
      </Steps>
    </ConfigProvider>
  );
};

export default TrebbleSteps; 